@if (readonly()) {
  <span
    [ngClass]="{
      'readonly-value': true,
      large: size() === 'large',
      error: hasError()
    }"
    >{{ transformedInputText() || placeholder() }}</span
  >
} @else {
  <input
    [ngClass]="{
      large: size() === 'large',
      error: hasError()
    }"
    type="text"
    [required]="required()"
    [placeholder]="placeholder()"
    [readOnly]="readonly()"
    [disabled]="disabled()"
    [value]="transformedInputText()"
    (input)="onInput($event)"
    (change)="onChange($event)"
    [attr.aria-label]="label()"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    #inputReference
  />
  <span class="input-width-expander" aria-hidden="true" [innerHTML]="widthExpanderText()"></span>
  @if (hasError()) {
    <ftr-icon [icon]="'Warning'" [align]="'Top'" [size]="'Regular'"></ftr-icon>
  }
}
